import './NavLinkExtended.scss';

import cn from 'classnames';
import React, { forwardRef, useMemo } from 'react';
import { NavLink } from 'react-router-dom';

import {
  NavLinkExtendedDefaultProps,
  NavLinkExtendedPropTypes,
} from './NavLinkExtended.proptypes';

const NavLinkExtended = forwardRef(({ ...props }, ref) => {
  const {
    activeClassName,
    children,
    className,
    context,
    disabled,
    disabledto,
    onClick,
    to,
  } = props;

  /**
   * Generate "to" NavLink
   * @type {string}
   */
  const getTo = useMemo(() => (disabled ? disabledto : to), [
    disabled,
    disabledto,
    to,
  ]);

  // TODO: fix active problem when disabled
  return (
    <NavLink
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      aria-disabled={disabled}
      className={cn('nav-link-extended', className, {
        'nav-link-extended--disabled': disabled,
      })}
      onClick={disabled ? (e) => e.preventDefault : onClick}
      ref={ref}
      to={getTo}
      activeClassName={disabled ? '' : activeClassName}
      data-qa-id={`${context || 'nav-link'}-${
        disabled ? 'disabled' : 'active'
      }`}
    >
      {children}
    </NavLink>
  );
});

NavLinkExtended.defaultProps = {
  ...NavLinkExtendedDefaultProps,
};

NavLinkExtended.propTypes = {
  ...NavLinkExtendedPropTypes,
};

export default NavLinkExtended;
